import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import TreeNode from "./TreeNode";
import { toggleNode } from "./nodeOperations";
import { selectTreeState, setTreeState } from "../slice";

const NodeContainer = styled.div`
  width: 100%;
  height: fit-content;
  padding: 4px;
`;

/**
 * Allows the user to select multiple columns from a tree where
 * each subtree represents a group. See {@link ApiGroups}.
 */
const ColumnTreeView = () => {
  const treeState = useSelector(selectTreeState);
  const dispatch = useDispatch();
  const toggle = React.useCallback(
    (nodeId) => {
      const currentNode = treeState.find((node) => node.id === nodeId);
      if (!currentNode) {
        throw new Error(`Could not find node with id='${nodeId}'.`);
      }
      console.debug(
        `Clicked on nodeId='${nodeId}', current value is '${currentNode.nodeState}'.`
      );

      const nextTreeState = toggleNode(treeState, currentNode);
      dispatch(setTreeState(nextTreeState));
    },
    [treeState, dispatch]
  );

  return (
    <NodeContainer>
      {treeState.map((node) => {
        return (
          <TreeNode
            key={node.id}
            id={node.id}
            level={node.level}
            displayName={node.displayName}
            nodeState={node.nodeState}
            toggle={toggle}
          />
        );
      })}
    </NodeContainer>
  );
};

export default ColumnTreeView;
